/**
 * The full-page "Upgrade" teaser: what a module the school switched off looks
 * like to the roles that may see it (ADMIN / PRINCIPAL / CHAIRMAN / DIRECTOR).
 * Used by the route guard (`components/setup/require-entitlement.tsx`) and by
 * pages that gate a tab in place (the Expenses tab of /finance).
 *
 * It renders no module code, so it fetches nothing.
 */
import { ArrowLeftFill as ArrowLeft, LockFill } from "@/components/icons/solid-extra-icons";
import { MODULE_UPGRADE_CONTACT_HREF, MODULE_UPGRADE_COPY, moduleLabelFor } from "./module-lock";
import "@/components/gates-native.css";
import "./module-lock.css";

export function ModuleTeaserPage({
  moduleKey,
  planName,
  onBack,
  backLabel = "Back to dashboard",
}: {
  moduleKey: string;
  planName?: string | null;
  onBack: () => void;
  backLabel?: string;
}) {
  const label = moduleLabelFor(moduleKey);
  return (
    <div className="ch-teaser" data-module-gate="locked" data-locked-module={moduleKey}>
      <section className="ch-teaser__card" aria-labelledby="ent-gate-title">
        <header className="ch-teaser__head">
          <span className="ch-teaser__icon" aria-hidden>
            <LockFill size={20} />
          </span>
          <div className="min-w-0">
            <p className="ch-teaser__eyebrow">Locked — not in your plan</p>
            <h1 id="ent-gate-title" className="ch-teaser__title">{label}</h1>
          </div>
        </header>
        <div className="ch-teaser__body">
          <p>{MODULE_UPGRADE_COPY}</p>
          <p>
            {label} is switched off for your school{planName ? ` (plan: ${planName})` : ""}. Nothing is lost: it turns
            back on with its data as soon as it is enabled.
          </p>
        </div>
        <footer className="ch-teaser__foot">
          <a className="sd-btn sd-btn--primary" href={MODULE_UPGRADE_CONTACT_HREF}>
            Contact CampusHub
          </a>
          <button type="button" className="sd-btn" onClick={onBack}>
            <ArrowLeft size={15} />
            {backLabel}
          </button>
        </footer>
      </section>
    </div>
  );
}
